<template>
  <div class="gray_block">
    <div class="wrapper_check_block clearfix">
      <div class="checkMark">
          <img class="img-fluid" src="../../assets/images/png/check_1.png" alt="Example of a valid receipt photo">
          <img class="checkMark_img checkMark_img_1" src="../../assets/images/svg/checkMark.svg" alt="Checkmark icon" aria-hidden="true">
      </div>
      <div class="checkMark">
          <img class="img-fluid" src="../../assets/images/png/check_3.png" alt="Example of an invalid receipt photo">
          <img class="cross_red_img cross_red_img_3" src="../../assets/images/svg/cross_red.svg" alt="Cross icon" aria-hidden="true">
      </div>
      <div class="checkMark">
          <img class="img-fluid" src="../../assets/images/png/check_4.png" alt="Example of an invalid receipt photo">
          <img class="cross_red_img cross_red_img_4" src="../../assets/images/svg/cross_red.svg" alt="Cross icon" aria-hidden="true">
      </div>
      <div class="checkMark">
          <img class="img-fluid" src="../../assets/images/png/check_2.png" alt="Example of an invalid receipt photo">
          <img class="cross_red_img cross_red_img_2" src="../../assets/images/svg/cross_red.svg" alt="Cross icon" aria-hidden="true">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "receipt-examples",
  props: {
  },
  methods: {
    pull () {
      this.pullDown = !this.shouldDisplayFull ? !this.pullDown : false
    }
  }
};
</script>
<style lang="scss" scoped>
  .gray_block {
    background-color: transparent;
    padding: 30px;
    border-radius: 4px;

    @media (max-width: 991px) {
      padding: 40px 60px;
    }
    @media (max-width: 767px) {
      padding: 10px 15px;
    }
    .inner_gray_block {
      text-align: center;
      margin-bottom: 50px;
    }
  }
  .checkMark {
    position: relative;
    float: left;
    margin: 15px;
    background-color: #EDEDED;
    &:first-child {
      margin-left: 0px;
    }
    .checkMark_img {
      position: absolute;
      top: 100px;
      left: 100%;
      margin-left: -27px;
      @media (max-width: 767px) {
        max-width: 30px;
        margin-left: -15px;
      }
    }
    .cross_red_img {
      position: absolute;
      top: 100px;
      left: 100%;
      margin-left: -18px;
      @media (max-width: 767px) {
        max-width: 24px;
        margin-left: -12px;
      }
    }
  }
  .wrapper_check_block {
    padding-top: 90px;
    display: flex;
    justify-content: space-around;
    @media (max-width: 991px) {
      flex-wrap: wrap;
      padding-top: 0;
    }
  }

</style>
